export const PUBLISHER_BENEFITS_DATA = {
  benefits: [
    {
      color: 'deeplilac',
      copy: 'The Podlove team has committed to the Open Source idea right from the start. We share our code on GitHub and are MIT licensed. So you can contribute to our projects and participate in the development of Podlove. And since our goal is to fund the development through contributions from the community – be it monetary or through work at the project – we\'re committed to keep Podlove free for all users.',
      icon: '../images/icons/open-source--white.png',
      title: 'Free & Open Source',
    },
    {
      color: 'copper',
      copy: 'Our goal from the beginning on was to put you in the driver\'s seat of your podcast. Since podcasting is one of the last untamed regions of the internet we want to contribute our share to that idea. So you can use the Podlove plugin and all the other tools with your WordPress no matter where you\'re hosting. With Podlove you have complete control of your audio files, your metadata, your settings and statistics.',
      icon: '../images/icons/server--white.png',
      title: 'Self Hosted',
    },
    {
      color: 'marguerite',
      copy: 'We use WordPress as the foundation we built upon. With its base in blogging and a "down to earth" approach for anyone who wants to start publishing their own content it was the perfect choice for Podlove. Furthermore, we build on the rich plugin ecosystem that allows us to integrate perfectly in your existing blog.',
      icon: '../images/icons/wordpress--white.png',
      title: 'Build on WordPress',
    },
    {
      color: 'roman',
      copy: 'Ever wondered how many listeners you have or how popular a specific episode is? With our Analytics module you\'ll have this information all at the ready – and even more. You can filter and compare different time frames, find out what clients your listeners use to listen to your show or see, which audio format from the ones you provide is the most popular. And all that in accordance with the GDPR since we don\'t store any personal information of your listeners.',
      icon: '../images/icons/analytics--white.png',
      title: 'Analytics',
    },
    {
      color: 'cucumber',
      copy: 'Let your listeners read along while they\'re listening to your podcast. As one of the first (and few) podcast players, the built in Podlove Web Player allows you to show transcripts of your show that work both ways: They always show the segment of your podcast playing right now and you can search and find text within your podcast – and by clicking on it, the player skips to the corresponding audio. In the Publisher backend you can assign transcripts and speakers to your show that can also be used by other clients if they support this feature.',
      icon: '../images/icons/transcript--white.png',
      title: 'Transcripts',
    },
    {
      color: 'pictonblue',
      copy: 'Enrich your podcast with detailed shownotes. Podlove lets you import your shownotes from different sources, be it HTML or Slack and presents them in a clean way.',
      icon: '../images/icons/shownotes--white.png',
      title: 'Shownotes',
    },
  ]
}